export type StepConfig = {
  id: string;
  ignoreModalTitle?: boolean;
  ignoreModalActions?: boolean;
  customTitle?: string;
  buttonText?: string;
  inputFields?: InputField[];
  children?: React.ReactNode;
  title?: string;
  titleLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  subtitle?: string;
  buttonAlign?: "left" | "right";
};

export type InputField = {
  label: string;
  hint?: string;
  element: "input-group" | "chip";
  fieldId: string;
  options?: { option: string; id: string }[];
  multiple?: boolean;
};

export type Steps = StepConfig[];

export const steps: Steps = [
  {
    id: "start",
    ignoreModalTitle: true,
    ignoreModalActions: true,
    customTitle: "Welcome to Dovetail",
    subtitle: "Your journey to a certified medical device starts now!",
    buttonText: "Let's start",
  },
  {
    id: "survey-name",
    title: "What is your name?",
    inputFields: [
      { label: "First Name", fieldId: "firstName", element: "input-group" },
      { label: "Last Name", fieldId: "lastName", element: "input-group" },
    ],
  },
];
